import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [compare, setCompare] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("lr_compare") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("lr_compare", JSON.stringify(compare));
  }, [compare]);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };

  const registerClient = async (payload) => {
    const { data } = await api.post("/auth/register-client", payload);
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const toggleCompare = (vehicle) => {
    setCompare((prev) => {
      const exists = prev.find((v) => v.id === vehicle.id);
      if (exists) return prev.filter((v) => v.id !== vehicle.id);
      if (prev.length >= 3) return prev;
      return [...prev, vehicle];
    });
  };

  const clearCompare = () => setCompare([]);

  return (
    <AuthContext.Provider
      value={{ user, setUser, login, register, registerClient, logout, refreshUser, compare, toggleCompare, clearCompare }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
